import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AudioRecordingService } from '../audio-recording.service';
import * as RecordRTC from 'recordrtc';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-audio',
    templateUrl: './audio.component.html',
    styleUrls: ['./audio.component.css'],
})
export class AudioComponent implements OnInit {
    startRecording = 'assets/img/voiceRecording.svg';
    stopRecording = 'assets/img/stopRecording.svg';
    pauseRecording = 'assets/img/pauseRecording.svg';
    recording = 'assets/img/recording.svg';

    isAudioRecording = false;
    audioRecordedTime = '00:00';
    audioBlobUrl;
    audioBlob;
    audioName;
    mediaStream: MediaStream;
    recordRTC: any;

    constructor(private audioRecordingService: AudioRecordingService, private sanitizer: DomSanitizer, private ref: ChangeDetectorRef, private http: HttpClient) {
        this.audioRecordingService.getRecordedBlob().subscribe((data) => {
            this.audioBlob = data.blob;
            this.audioName = data.title;
            this.audioBlobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));

            this.ref.detectChanges();
        });

        this.audioRecordingService.getRecordedTime().subscribe((time) => {
            this.audioRecordedTime = time;
            this.ref.detectChanges();
        });
    }

    ngOnInit(): void {}

    getImages(): void {
        this.http.get('/assets/data/images.json').subscribe((res: any) => {
            this.startRecording = res.startRecording;
            this.stopRecording = res.stopRecording;
            this.pauseRecording = res.pauseRecording;
            this.recording = res.recording;
        });
    }

    startAudioRecording() {
        if (!this.isAudioRecording) {
            this.isAudioRecording = true;
            this.audioRecordingService.startRecording();
        }
        // navigator.mediaDevices
        // .getUserMedia({ audio: true, video: true })
        // .then((stream) => {
        // 	this.mediaStream = stream;
        // 	this.recordRTC = RecordRTC(stream, {
        // 		type: "audio",
        // 	});
        // 	this.recordRTC.startRecording();
        // })
        // .catch((err) => console.error(err));
    }

    stopAudioRecording() {
        if (this.isAudioRecording) {
            this.audioRecordingService.stopRecording();
            this.isAudioRecording = false;
        }

        // this.recordRTC.stopRecording(() => {
        // 	// Do something with the recorded data
        // 	const recordedBlob = this.recordRTC.getBlob();
        // 	console.log(recordedBlob);
        // 	// Save the recordedBlob or handle it as needed
        // });
    }
}
